import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { parseJWT } from "../../utils/jwtUtils";

import { MdOutlineLeaderboard } from "react-icons/md";

import { FaMoneyBillWave } from "react-icons/fa";
import { GiTwoCoins } from "react-icons/gi";
import { BsCashStack } from "react-icons/bs";
import { PiMedalFill } from "react-icons/pi";
import { MdSupportAgent } from "react-icons/md";

const HomePageFooter = () => {
  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;

  const userInfo = parseJWT(token?.token);

  const navigate = useNavigate();

  const [showFooter, setShowFooter] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        setShowFooter(false);
      } else {
        setShowFooter(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const footerMenus = [
    {
      title: "Wallet",
      amharic: "ዋሌት",
      icon: <FaMoneyBillWave size={20} />,
      onClick: () => navigate("/wallet"),
    },
    {
      title: "History",
      amharic: "መረጃ",
      icon: <BsCashStack size={20} />,
      onClick: () => navigate("/history"),
    },
    {
      title: "Contact",
      amharic: "አግኙን",
      icon: <GiTwoCoins size={20} />,
      onClick: () => window.open("https://t.me/bingo", "_blank"),
    },
    {
      title: "Profile",
      amharic: "ስለ እኛ",
      icon: <PiMedalFill size={22} />,
      onClick: () => navigate("/profile"),
      active: true,
    },
    {
      title: "Leaderboard",
      amharic: "መሪዎች",
      icon: <MdOutlineLeaderboard size={22} />,
      onClick: () => navigate("/leaderboard"),
    },
  ];

  return (
    <>
      {/* 🔻 Main Footer */}
      <div
        style={{
          transition: "transform 0.3s ease-in-out",
          transform: showFooter ? "translateY(0)" : "translateY(120%)",
        }}
        className="fixed bottom-1 left-0 right-0 z-50 block md:hidden"
      >
        <div className="mx-auto flex w-[98%] items-center justify-between gap-2 rounded-2xl border border-cyan-700 bg-[#004b4d] px-2 py-2 shadow-2xl">
          {footerMenus.map((item, index) => (
            <button
              key={index}
              onClick={item.onClick}
              className={`
                relative flex w-full flex-col items-center justify-center
                rounded-2xl px-1 py-2
                transition-all duration-300
                ${
                  item.active
                    ? "scale-105 border border-yellow-300 bg-gradient-to-b from-yellow-700 to-yellow-500 text-white shadow-lg"
                    : "bg-[#005e60] text-white hover:bg-[#0b7274]"
                }
              `}
            >
              {/* Icon */}
              <div className="mb-1">{item.icon}</div>

              {/* English */}
              <span className="text-[12px] font-semibold leading-tight">
                {item.title}
              </span>

              {/* Amharic */}
              <span className="text-[10px] leading-tight opacity-90">
                {item.amharic}
              </span>
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default HomePageFooter;
